import { Component } from '@angular/core';

@Component({
  selector: 'app-possibilities',
  templateUrl: './possibilities.component.html',
  styleUrls: ['./possibilities.component.scss']
})
export class PossibilitiesComponent {

}
